import { createFileRoute, useParams } from '@tanstack/react-router';
import { JourneysDataIndexHandoff } from '@/pages/workspaces/data-index/routing';
import { DataIndexTypeResolver } from '@/pages/workspaces/data-index/data-index-type-resolver';
import { LastWorkspaceResolver } from './-route-helpers';

function JourneysDataIndexTypeRoute() {
  const { type } = useParams({ from: '/_authenticated/workspaces/$workspaceId/journeys/data-index/$type/' });

  return (
    <LastWorkspaceResolver>
      <DataIndexTypeResolver segment={type}>
        {(dataIndexType) => <JourneysDataIndexHandoff type={dataIndexType} />}
      </DataIndexTypeResolver>
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/data-index/$type/')({
  component: JourneysDataIndexTypeRoute,
});
